import React from "react";

const ReportFooter = ({ link }) => {
  return (
    <div className="report-footer d-flex justify-content-center mt-4 no-print">
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-info"
      >
        Print
      </a>
    </div>
  );
};

export default ReportFooter;
